import React, { useState } from 'react'

import { ExpandMore as ExpandMoreIcon } from '@material-ui/icons'
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Typography,
} from '@material-ui/core'

import { useHistory, useParams } from 'react-router-dom'

import { Container, ContentHeader, LoadingFeedback, Page } from 'components'

import { KpiForm } from './components'
import KpiMetricsTable from './components/KpiMetrics'

import * as service from 'service'
import { routes } from 'Routes'

import useFetch from 'hooks/useFetch'

const KpiShow = () => {
  const [expanded, setExpanded] = useState(false)
  const [openMetricModal, setOpenMetricModal] = useState(false)

  const history = useHistory()

  const { monitoringManagementKpiId } = useParams()

  const { response, isLoading, refresh } = useFetch(
    service.dponet.monitoringManagementKpi.show,
    { monitoringManagementKpiId },
    [monitoringManagementKpiId],
  )

  const monitoringManagementKpi = response?.data?.monitoringManagementKpi

  const handleAccordionChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false)
  }

  return (
    <Page title="Edição de Projeto - Monitoramento">
      <LoadingFeedback open={isLoading} />
      <Container maxWidth={false}>
        <ContentHeader title="KPI" />
        <Accordion
          expanded={expanded === 'panel-kpi'}
          onChange={handleAccordionChange('panel-kpi')}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel-kpi-content"
            id="panel-kpi-header"
          >
            <Typography
              style={{
                fontWeight: '700',
              }}
            >
              Clique aqui para visualizar o KPI
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <KpiForm
              isShow={true}
              monitoringManagementKpi={monitoringManagementKpi}
              refresh={refresh}
            />
          </AccordionDetails>
        </Accordion>
        <Typography
          style={{
            fontWeight: 600,
            marginTop: 40,
            marginBottom: 40,
          }}
          variant="h3"
          color="textPrimary"
        >
          Métricas
        </Typography>
        <KpiMetricsTable
          monitoringManagementKpi={monitoringManagementKpi}
          openMetricModal={openMetricModal}
          setOpenMetricModal={setOpenMetricModal}
        />
        <Box ml={2} mt={2} display="flex" justifyContent="flex-end">
          <Box pr={1}>
            <Button
              type="button"
              variant="outlined"
              onClick={() => history.push(routes.kpi.all)}
            >
              Voltar
            </Button>
          </Box>
        </Box>
      </Container>
    </Page>
  )
}

export default KpiShow
